import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

import VerifiedIcon from "@mui/icons-material/Verified";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import DoneIcon from "@mui/icons-material/Done";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";

import { API_URL } from "../../config";
import AdsPanel from "./AdsPanel";

function SearchResults() {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search");

  const [users, setUsers] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  //const [loading, setLoading] = useState(true);

  const uploads = "https://skychunks.store/uploads";

  useEffect(() => {
    const fetchSearchResults = async () => {
      try {
        const response = await fetch(
          `${API_URL}/api-get-user-searching.php?search=${encodeURIComponent(
            search || ""
          )}`
        );

        const responseData = await response.json();
        console.log(responseData);

        setUsers(responseData.data || []);
      } catch (error) {
        console.error("Error fetching search results:", error);
      } finally {
        //setLoading(false);
      }
    };

    fetchSearchResults();
  }, [search]);


  return (
    <div>
      <div className="breadcrumb">
        <Link to="/">Home</Link> &nbsp;: Search Results
      </div>

      <div className="ibodywrap">
        <div className="row">
          <div className="col-md-9">

            {users.length > 0 ? (
              users.map((user, index) => {
                const services = user.business_services
                  ? user.business_services.split(",")
                  : [];

                return (
                  <div key={user.id || index} className="business-listing fade-in" >
                    <div className="imgbox">
                      {user.business_logo && ( <img src={`${uploads}/${user.business_logo}`} alt={user.business_fullname} width="100" />  )}
                      <div className="businesstype" style={{ display: "none" }}>Wholesale</div>
                    </div>

                    <div className="detail-box">
                      <div className="title-box">
                        <Link to={`/${user.category_url}/${user.page_url}`}><VerifiedIcon /> {user.business_fullname} </Link>
                      </div>

                      <div className="location-box">
                        <FmdGoodOutlinedIcon />{" "}
                        {user.business_address}, {user.business_city},{" "}{user.business_district}, {user.business_state} -{" "} {user.business_zipcode}
                      </div>

                      {user.user_category === "Doctors" && (
                        <div className="dr-sdetails">
                          <span className="sp1">{user.doctor_category}</span>
                          <span className="sp2">
                            {user.doctor_type === "Both"
                              ? "Physician & Surgeon"
                              : user.doctor_type}
                          </span>
                          <span className="sp3">{user.doctor_degree}</span>
                        </div>
                      )}

                      <div className="service-box">
                        {services 
                        .slice( 0, expandedIndex === index ? services.length : 6 )
                          .map((service, i) => (
                            <div key={i} className="services"> <DoneIcon /> {service.trim()} </div>
                          ))}

                        {services.length > 6 && (
                          <div className="services-more" onClick={() => setExpandedIndex( expandedIndex === index ? null : index ) } style={{ cursor: "pointer", color: "blue", }} >
                            {expandedIndex === index ? "Show Less" : `+${services.length - 6} more`}
                          </div>
                        )}
                      </div>

                      <div className="btn-box">
                        <a href={`tel:${user.business_contactno1}`} className="contact-no"><CallRoundedIcon />{user.business_contactno1}</a>
                        <a href={`https://wa.me/${user.business_whatsappno}`} className="whatsapp" target="_blank" rel="noopener noreferrer"><WhatsAppIcon />{user.business_whatsappno}</a>
                        <a href={`mailto:${user.email}`} className="contact-no"><MarkEmailUnreadOutlinedIcon />Send Enquiry</a>
                      </div>
                    </div>

                    <div className="clr"></div>
                  </div>
                );
              })
            ) : (
              <div className="business-listing fade-in">
                <p style={{ margin: 0, color: "red" }}>No results found.</p>
              </div>
            )}
          </div>

          <div className="col-md-3">
            <AdsPanel />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchResults;